/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdel_Nein8Inputs */

const en__field_enum_sdel_nein8 = /** @type {(inputs: _Field_Enum_Sdel_Nein8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const de__field_enum_sdel_nein8 = /** @type {(inputs: _Field_Enum_Sdel_Nein8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {_Field_Enum_Sdel_Nein8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdel_nein8 = /** @type {((inputs?: _Field_Enum_Sdel_Nein8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdel_Nein8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdel_nein8(inputs)
	return de__field_enum_sdel_nein8(inputs)
});
export { _field_enum_sdel_nein8 as "_field_enum_SDEL_NEIN" }